import { PLATFORM_URL } from "app/constants/variables";
import { GenericResponse } from "../types";
import { Currency } from "app/models/currency";
import request from "../request";
import { ListCurrenciesQuery } from "./types";

export const listCurrencies = (params?: ListCurrenciesQuery) => {
  const { publicKey, ...rest } = params ?? {};
  return request.get<GenericResponse<Currency[]>>("v1/currencies", {
    baseURL: PLATFORM_URL,
    params: rest,
    ...(publicKey && {
      headers: {
        "X-BU-PUBLIC-KEY": publicKey,
      }
    }),
  });
};
